import { useToast, Box, Text, Grid } from '@chakra-ui/react';
import React from 'react';
import { useEffect } from 'react';
import { styles } from './toast.styles';
import { ToastPositions, ToastVariants } from '../../core/enums';
import { BiomeIcon, IconName } from '@codametrix/verdigris';

export type ToastProps = {
  duration?: number;
  position?: ToastPositions;
  status?: string;
  feedback: CMxCommonApp.Feedback;
};

const Toast: React.FC<ToastProps> = props => {
  const { feedback, duration = 5000, position = ToastPositions.BOTTOM } = props;

  const toast = useToast();
  const classes = styles(feedback.status ?? ToastVariants.SUCCESS);

  const getIcon = (variant: string) => {
    switch (variant) {
      case ToastVariants.SUCCESS: {
        return (
          <BiomeIcon
            iconName={IconName.Check_Circle}
            iconClass={`${classes.successIcon}`}
            iconSize="12"
            titleText="Success"
          />
        );
      }
      case ToastVariants.INFO:
      case ToastVariants.WARNING: {
        return (
          <BiomeIcon
            iconName={IconName.Info}
            iconClass={`${classes.infoIcon}`}
            titleText="Info"
          />
        );
      }
      case ToastVariants.ERROR: {
        return (
          <BiomeIcon
            iconName={IconName.Cancel_Circle}
            iconClass={`${classes.calendarIcon}`}
            titleText="Cancel"
          />
        );
      }
      default: {
        console.warn('Invalid variant ', variant);
        break;
      }
    }
  };

  useEffect(() => {
    if (feedback.message) {
      toast({
        duration: duration,
        position: position,
        status: 'error',
        isClosable: true,
        render: ({ onClose }) => {
          return (
            <Box sx={classes?.container}>
              <Grid sx={classes?.grid}>
                {getIcon(feedback.status ?? ToastVariants.SUCCESS)}
                <Text sx={classes?.text}>{feedback.message}</Text>
              </Grid>
              <Grid sx={classes?.icon} data-testId="close" onClick={onClose}>
                <BiomeIcon iconName={IconName.Cancel} titleText="Close" />
              </Grid>
            </Box>
          );
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [feedback]);

  return null;
};

Toast.displayName = 'Toast';
export { Toast };
